import type { DeepPartial } from '@luna/utils-ts';

import type { PaymentOrders } from './PaymentOrders';

export const RS: DeepPartial<PaymentOrders> = {
    shouldShowOwnTransferAsDomesticIcon: true,
    shouldShowPurposeCodeOrderValue: true,
    alwaysRedo: false,
    failedOrderStates: [
        'BAN',
        'CBB',
        'KAG',
        'RDE',
        'SNM',
        'NGD',
        'NGA',
        'ADB',
        'NBA',
        'CBA',
        'CSA',
        'LGR',
        'BLA',
        'ABG',
        'BBC',
        'AGB',
        'OBG',
        'UNG',
        'BNZ',
        'ENE',
        'FUS',
        'UNK',
        'DDB',
        'DDD',
        'DDL',
        'DDC',
        'RED',
        'XPR',
        'BAM',
        'BPA',
        'BPR',
        'EEI',
        'FRD',
        'IPA',
        'IPC',
        'IPE',
        'ISA',
        'RBC',
        'REC',
    ],
};
